export enum VentureContactModalMode {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
